import { useEffect, useRef } from 'react'

const ONE_HOUR = 60 * 60 * 1000
const STAGGER_WINDOW = 5 * 60 * 1000 // 5 minutes

export function usePolling(fetchDataFn: () => Promise<void>) {
	const timerRef = useRef<NodeJS.Timeout | null>(null)

	const scheduleNextFetch = () => {
		const randomOffset = Math.floor(Math.random() * STAGGER_WINDOW * 2) - STAGGER_WINDOW
		const delay = ONE_HOUR + randomOffset

		timerRef.current = setTimeout(() => {
			fetchAndStore()
			scheduleNextFetch()
		}, delay)
	}

	const fetchAndStore = async () => {
		const now = Date.now()
		try {
			await fetchDataFn()
			localStorage.setItem('lastOfflineCache', now.toString())
		} catch (err) {
			console.error('Failed to fetch:', err)
		}
	}

	useEffect(() => {
		const last = parseInt(localStorage.getItem('lastOfflineCache') || '0', 10)
		const now = Date.now()

		if (now - last > ONE_HOUR) {
			fetchAndStore()
		}

		scheduleNextFetch()

		const handleVisibility = () => {
			if (document.visibilityState === 'visible') {
				const now = Date.now()
				const last = parseInt(localStorage.getItem('lastOfflineCache') || '0', 10)
				if (now - last > ONE_HOUR) {
					fetchAndStore()
				}
			}
		}

		document.addEventListener('visibilitychange', handleVisibility)

		return () => {
			if (timerRef.current) clearTimeout(timerRef.current)
			document.removeEventListener('visibilitychange', handleVisibility)
		}
	}, [fetchDataFn])
}
